/**
 * Journey step types used to build human-readable journey events for
 * Datadog RUM.
 *
 * Capture model: ALL journey event fields are captured and forwarded as-is.
 * There is no allow-list, deny-list, or field masking in this module — our
 * Datadog RUM configuration already applies PII masking at the platform
 * level, so this feature captures confidently rather than duplicating that
 * responsibility here. See ./README.md for details.
 */

export const JOURNEY_STEP_TYPES = Object.freeze({
  ROUTE_VIEW: "route.view",
  API_SUCCESS: "api.success",
  API_FAILURE: "api.failure",
  USER_MILESTONE: "user.milestone",
} as const);

export type JourneyStepType = (typeof JOURNEY_STEP_TYPES)[keyof typeof JOURNEY_STEP_TYPES];
